// extracted by mini-css-extract-plugin
export default {"rowCards":"CardsLoading_rowCards__joiDe"};